import { render, staticRenderFns } from "./YtDetailTab.vue?vue&type=template&id=7104fb93&scoped=true&"
import script from "./YtDetailTab.vue?vue&type=script&lang=js&"
export * from "./YtDetailTab.vue?vue&type=script&lang=js&"
import style0 from "./YtDetailTab.vue?vue&type=style&index=0&id=7104fb93&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7104fb93",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
